"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var PublishPriceMobile_1 = __importDefault(require("./PublishPriceMobile"));
function PublishPrice(props) {
    var className = props.className, style = props.style, _a = props.mainList, mainList = _a === void 0 ? [] : _a, _b = props.headerList, headerList = _b === void 0 ? [] : _b, headerTitle = props.headerTitle;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    /**
     * 渲染头部item
     * @param item list数据
     * @param index map循环的index
     */
    function renderHeaderItem(item, index) {
        var title = item.title, desc = item.desc;
        return (react_1.default.createElement("div", { className: "header-wrap", key: index },
            react_1.default.createElement("div", { className: "header-title" }, title),
            desc ? react_1.default.createElement("div", { className: "header-desc" }, desc) : null));
    }
    /**
     * 渲染头部
     */
    function renderHeader() {
        return (react_1.default.createElement("div", { className: "publish-price-header" },
            react_1.default.createElement("div", { className: "header-one" },
                react_1.default.createElement("div", { className: "header-one-txt" }, headerTitle)), headerList === null || headerList === void 0 ? void 0 :
            headerList.map(renderHeaderItem)));
    }
    /**
     * 渲染竖版布局
     */
    function renderTableItem(item, index) {
        var title = item.title, desc = item.desc;
        return (react_1.default.createElement("div", { className: "content-item", key: index },
            react_1.default.createElement("div", { className: "content-item-title" }, title),
            desc ? react_1.default.createElement("div", { className: "content-item-desc" }, desc) : null));
    }
    /**
     * 渲染竖版价格套餐列表
     * @param item list数据
     * @param index map循环的index
     */
    function renderTable() {
        return react_1.default.createElement("div", { className: "content-wrap" }, mainList === null || mainList === void 0 ? void 0 : mainList.map(renderTableList));
    }
    /**
     * 渲染竖版价格套餐列表
     * @param item list数据
     * @param index map循环的index
     */
    function renderTableList(item, index) {
        var columnTitle = item.columnTitle, _a = item.contentList, contentList = _a === void 0 ? [] : _a;
        return (react_1.default.createElement("div", { className: "publish-price-content", key: index },
            react_1.default.createElement("div", { className: "content-title" },
                react_1.default.createElement("div", { className: "content-title-txt" }, columnTitle)), contentList === null || contentList === void 0 ? void 0 :
            contentList.map(renderTableItem)));
    }
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)(className, "".concat(classPrefix, "-publish-price")) },
        react_1.default.createElement("div", { className: "publish-price-list" },
            renderHeader(),
            renderTable()),
        react_1.default.createElement(PublishPriceMobile_1.default, __assign({}, props))));
}
exports.default = PublishPrice;
//# sourceMappingURL=PublishPrice.js.map